
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/speaker-rental",
      function () {
        return require("private-next-pages/speaker-rental.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/speaker-rental"])
      });
    }
  